import { Nullable } from "../../../../types/common";
import { formatDate } from "../../../../utils/date-format.utils";

export const Date = (date: Nullable<string>, format: string = "MMM DD") => {
  return formatDate(date, format) ?? "-";
};
